import {faEnvelope} from "@fortawesome/free-regular-svg-icons";
import {faArrowRight, faEye, faEyeSlash, faLock} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useOktaAuth} from "@okta/okta-react";
import "bootstrap/dist/css/bootstrap.min.css";
import React, {useEffect, useState} from "react";
import "../assets/sass/pages/InsuredSignIn.scss";
import AccessAgreementModal from "../components/AccessAgreementModal.js";
import LoadingSpinner from "../components/LoadingSpinner.js";
import SessionRedirectModal from "../components/SessionRedirectModal.js";
import {Icon, Icons} from "../icons.jsx";

const InsuredSignInForm = () => {
  const {oktaAuth} = useOktaAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [hasSigninError, setHasSignInError] = useState(false);
  const [loginErrorText, setLoginErrorText] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [showSessionRedirect, setShowSessionRedirect] = useState(false);
  const [showAccessAgreement, setShowAccessAgreement] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    oktaAuth.session.get()
      .then(({login}) => {
        if (login) {
          setShowSessionRedirect(true);
          window.location.href = oktaAuth.options.redirectUri;
        }
      }).catch(exception => {
      setHasSignInError(true);
      setLoginErrorText(exception.message);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = (action) => {
    action.preventDefault();
    setIsLoading(true);
    oktaAuth
      .idx.authenticate({
      username: username, password: password
    })
      .then((res) => {

        if (res.messages) {
          let containsError = res.messages.some(value => { return value.class === "ERROR"; });

          if (containsError) {
            setIsLoading(false);
            setHasSignInError(true);
            setLoginErrorText(<span>The information you have entered does not match our records.Please try again or call us for assistance at <a href="tel:8005431150">800-543-1150</a>.</span>);
            return false;

          }
        }
        window.location.href = oktaAuth.options.redirectUri;
      })
      .catch((err) => {
        setIsLoading(false);
        console.debug("Found an error", err);
        setHasSignInError(true);
        if (err.message.includes("reenroll-custom-password-expiry")) {

          fetch('/api/v2/reset-password-url')
            .then((res) => {
              return res.text();
            }).then((urlRes) => {
            setLoginErrorText(<span>The password you have entered has expired. Please follow this <a
              href={urlRes}>link</a> to reset.</span>);
          });
        }

        // the http status code determines which error message we show the user
        else if (err.message === "tempToken") {
          setLoginErrorText(
            <span>Your account has not been verified.<br></br> Please complete your registration or<br></br> contact customer care at&nbsp;
              <a href="tel:8005431150">800-543-1150</a>
              &nbsp;<br></br>for further assistance.</span>);
          return;
        }
        if (err.xhr) {
          switch (err.xhr.status) {
            case 401:
              setLoginErrorText(<span>The information you have entered does not match our records.Please try again or call us for assistance at&nbsp;
                <a href="tel:8005431150">800-543-1150</a>.</span>);
              break;
            case 500:
            default:
              setLoginErrorText(<span>An error has occurred, please call us for assistance at&nbsp;
                <a
                  href="tel:8005431150">800-543-1150</a>.</span>);
              break;
          }
        } else if (typeof err === 'string') {
          setLoginErrorText(err);
        } else {
          setLoginErrorText(err.message);
        }
      });
  };
  // This handler will submit the form if the "Enter" key is pressed
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent the default Enter key behavior (form submission)
      handleSubmit(e); // Manually calls the above submit handler
    }
  };

  const validateForm = () => {
    return username?.trim().length > 0 && password?.trim().length > 0;
  };

  const resetPasswordUrl = '/request-password-reset';

  const requestAccessUrl = '/registration';

  return (
    <div id={'insuredSignIn'}>
      {/*TODO colors are different in figma for alert-warning*/}
      <AccessAgreementModal
        show={showAccessAgreement}
        onClose={() => setShowAccessAgreement(false)}
      />
      <SessionRedirectModal
        show={showSessionRedirect}
      />
      {isLoading ? (
        <LoadingSpinner/>
      ) : (
        <div className="ga_login-app-middle-wrapper-container">
          <div className="ga_login-app-middle-wrapper-container-loginPanel">
            <div className="ga_loginPanelTile-container">
              <div className="ga_loginPanelTile-container-title">
                <h1>Policyholder Login</h1>
              </div>
            </div>
            <form onSubmit={handleSubmit} onKeyUp={handleKeyPress}>
              <div className="ga_loginInput-wrapper">
                <label id="emailLabel" htmlFor="email">
                  Email
                  <span>*</span>
                </label>

                <div
                  className="ga_loginInput-wrapper-inputWrapper"
                  role="presentation"
                >
                  <FontAwesomeIcon className="inputIcon" icon={faEnvelope}/>
                  <input
                    type="text"
                    id="email"
                    name="email"
                    placeholder="Enter your email"
                    aria-invalid="false"
                    aria-label="EMAIL"
                    value={username}
                    onChange={(element) => setUsername(element.target.value)}
                  />
                </div>
              </div>

              <div className="ga_loginInput-wrapper ga_loginInput-wrapper-padding">
                <div
                  id="form-group-password"
                  read-only="isDisabled(_component, data)"
                  unqorkio-form="unqorkioForm"
                  grid-row="gridRow"
                  grid-col="gridCol"
                  builder="builder"
                  options="options"
                >
                  <div>
                    <div>
                      <label htmlFor="password" className="">
                        PASSWORD{" "}
                        <span>*</span>
                      </label>
                      <div className="ga_loginInput-wrapper-inputWrapper">
                        <FontAwesomeIcon className="inputIcon"
                                         icon={faLock}
                        />
                        <input
                            type={showPassword ? 'text' : 'password'}
                            id="password"
                            name="password"
                            className={'form-control'}
                            placeholder="Enter your password"
                            autoComplete="off"
                            value={password}
                            onChange={(element) => setPassword(element.target.value)}
                        />
                        <div id="togglePasswordView" className="btn" onClick={() => setShowPassword(!showPassword)}>
                          <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye}/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id={'resetPasswordWrapper'}>
                    <a id={'resetPasswordLink'} href={resetPasswordUrl}>
                      <Icon
                        name={Icons.infoCircleOutline}
                        width={16}
                        height={16}
                      />
                      Forgot Password?
                    </a>
                  </div>
                </div>
              </div>
              {hasSigninError ? (
                <p id="failedSignInMessage">{loginErrorText}</p>
              ) : null}
              <div className="ga_loginPanel-bottom">
                <div className="button-wrapper">
                  <input
                    id="submit-insured"
                    className="ga_Button ga_Button-primary btn-md"
                    type="submit"
                    value="Log In"
                    disabled={!validateForm()}
                  />
                </div>
                <div id="textAccessAgreement">
                  <div className="ga_agrement-wrapper">
                    <p className="ga_access-text">
                      By clicking “Log in” you are accepting the terms of use in
                      the
                      <button
                        id="btnAccessAgreement"
                        name="btnAccessAgreement"
                        className="ga_Button link"
                        type="button"
                        onClick={() => setShowAccessAgreement(true)}
                      >
                        <span
                          id="accessagreement"
                          className="button-label"
                        >
                          Access Agreement
                        </span>
                      </button>
                    </p>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="ga_login-app-middle-wrapper-container-signPanel">
            <div className="ga_signup-text">
              <div>
                <h2 className="ga_signup-text-header">
                  Don't have an account?
                </h2>
              </div>
              <div>
                <div>
                  <p className="ga_signup-text-description">
                    Insureds can request access to this platform by clicking
                    the button below.
                  </p>
                </div>
              </div>
            </div>
            <div className="ga_Signup-AccessRequest">
              <a
                href={requestAccessUrl}
                className="ga_Signup-AccessRequest-Button"
              >
                Request Access<FontAwesomeIcon
                className="insRequestAccessArrow"
                icon={faArrowRight}
                size="lg"
              />
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InsuredSignInForm;
